<script setup lang="ts">
  import { ButtonVariant } from '@tundr/theme';
  import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
  import { computed } from 'vue';
  import {
    ButtonAlignmentVariant,
    type ButtonProps,
    ButtonWidthVariant,
  } from '../Button';
  import Button from '../Button/Button.vue';
  import FontIcon from '../FontIcon/FontIcon.vue';
  import { iconButtonBaseClass, iconClass } from './IconButton.css';

  export type IconButtonProps = ButtonProps & {
    iconName: TUNDR_ICONS;
  };

  const props = withDefaults(defineProps<IconButtonProps>(), {
    clickable: false,
    disabled: false,
    variant: ButtonVariant.transparentOutlined,
    width: ButtonWidthVariant.MIN,
  });

  const propsWithoutIconName = computed(() => {
    return {
      ...props,
      iconName: undefined,
    };
  });

  const emits = defineEmits<{
    click: [event: Event];
  }>();
</script>

<template>
  <Button
    v-bind="propsWithoutIconName"
    :id="id || testId"
    :data-test-id="testId"
    :title="title"
    :class="iconButtonBaseClass"
    :variant="variant"
    :width="width"
    :text-align="ButtonAlignmentVariant.CENTER"
    :role="'button'"
    @click="(e) => emits('click', e as MouseEvent)"
  >
    <FontIcon :icon-name="iconName" :class="iconClass" />
  </Button>
</template>
